import React from 'react';
import { Skeleton } from 'antd';
import MainHeader from '../../header/MainHeader';
import Footer from '../../footer/Footer';

const ListingDetailSkeleton: React.FC = () => (
  <div className="home-page-light listing-details-page">
    <MainHeader />
    <main style={{ paddingTop: 80 }}>
      <div className="listing-details-container">
        <div className="listing-layout">

          {/* Left column — gallery + content */}
          <div className="layout-left">
            <div className="skeleton-gallery">
              <div style={{ width: '100%', height: 500, background: '#f0f0f0', borderRadius: 'var(--hp-radius) var(--hp-radius) 0 0', animation: 'ant-skeleton-loading 1.4s ease infinite' }} />
              <div className="skeleton-thumbs">
                {[0, 1, 2, 3].map((i) => (
                  <div key={i} style={{ width: 110, height: 76, flexShrink: 0, background: '#e8e8e8', borderRadius: 8, animation: 'ant-skeleton-loading 1.4s ease infinite' }} />
                ))}
              </div>
            </div>
            <div className="content-section">
              <Skeleton active paragraph={{ rows: 4 }} />
            </div>
            <div className="content-section">
              <Skeleton active paragraph={{ rows: 6 }} />
            </div>
          </div>

          {/* Right column — price card */}
          <div className="layout-right">
            <div className="skeleton-info-card">
              <Skeleton active paragraph={{ rows: 3 }} />
              <div style={{ marginTop: 24 }}>
                <Skeleton.Button active block style={{ height: 52, borderRadius: 50 }} />
              </div>
              <div style={{ marginTop: 12 }}>
                <Skeleton.Button active block style={{ height: 52, borderRadius: 50 }} />
              </div>
            </div>
          </div>

        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default ListingDetailSkeleton;
